import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconFileTypeCsv = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7 4a1 1 0 0 0-1 1v7a1 1 0 1 1-2 0V5a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 20 8v4a1 1 0 1 1-2 0V9h-3a2 2 0 0 1-2-2V4zm8 1.414L16.586 7H15zm.684 8.637a1 1 0 0 1 1.265.633L18 17.838l1.051-3.154a1 1 0 0 1 1.898.632l-2 6a1 1 0 0 1-1.898 0l-2-6a1 1 0 0 1 .633-1.265m-11.952.681A2.5 2.5 0 0 1 8 16.5a1 1 0 1 1-2 0 .5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0 1 1 0 1 1 2 0 2.5 2.5 0 0 1-5 0v-3a2.5 2.5 0 0 1 .732-1.768m5.854-.146A2 2 0 0 1 11 14h1.25A1.75 1.75 0 0 1 14 15.75a1 1 0 0 1-1.969.25H11v1h1a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-1.25A1.75 1.75 0 0 1 9 20.25a1 1 0 0 1 1.969-.25H12v-1h-1a2 2 0 0 1-2-2v-1a2 2 0 0 1 .586-1.414"
            clipRule="evenodd"
        />
    </svg>
);
